import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ApplicationLayout as CoreApplicationLayout, ErrorBoundary, PageLoading, TrackNavigation } from "am-tax-fe-core";
import { Page } from "./Page";

function ApplicationLayout() {
    const location = useLocation();

    return (
        <>
            <ErrorBoundary location={location}>
                <CoreApplicationLayout appName={import.meta.env.VITE_APP_NAME}>
                    <Suspense
                        fallback={
                            <Page title={""}>
                                <PageLoading text={"Loading Components..."} />
                            </Page>
                        }
                    >
                        <Outlet />
                    </Suspense>
                </CoreApplicationLayout>
            </ErrorBoundary>
            <TrackNavigation location={location} />
        </>
    );
}

export default ApplicationLayout;
